import styled from 'styled-components';

const StyledLink = styled.p`
  ${({ theme }) => theme.typograph.ctaLabel}

  display: flex;
  justify-content: center;

  color: ${({ theme }) => theme.colors.mainColor};
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
  :hover {
    color: ${({ theme }) => theme.colors.mainColor};
  }
  :disabled {
    color: ${({ theme }) => theme.colors.gray400};
  }
`;

export {
  StyledLink,
};
